var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProbation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "how_to_reg_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M0,0H14V14H0Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1860",
    "data-name": "Ellipse 1860",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 3)",
    fill: "#d34a7c",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10930",
    "data-name": "Path 10930",
    d: "M5,17.192H7.911l-.577-.583.543-.548C6.487,16.217,5.117,16.824,5,17.192Z",
    transform: "translate(-2.083 -6.692)",
    fill: "#d34a7c",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M7.667,8.667A2.333,2.333,0,1,0,5.333,6.333,2.333,2.333,0,0,0,7.667,8.667Zm0-3.5A1.167,1.167,0,1,1,6.5,6.333,1.17,1.17,0,0,1,7.667,5.167Zm-.583,7H4.167c.117-.367,1.487-.974,2.876-1.132H7.06l.268-.262.922-.9a5.449,5.449,0,0,0-.583-.035C6.109,9.833,3,10.615,3,12.167v1.167H8.25Zm6.183-3.208-2.993,3.016L9.067,10.761l-.817.823,2.024,2.042,3.809-3.844Z",
    transform: "translate(-1.25 -1.667)",
    fill: "#d34a7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbation);
export default __webpack_public_path__ + "static/media/probation.8307b0a40f1be2d3b1ffece81f61a3c4.svg";
export { ForwardRef as ReactComponent };